import { AnimatePresence, motion } from 'framer-motion';
import { Box } from '~/commonComponents/Box';
import { Checkbox } from '~/commonComponents';
import { Column } from '~/commonComponents/Column';
import { Row } from '~/commonComponents/Row';
import { OutlineDoubleCheckSentIcon, SolidHeartIcon } from '@tempmee/react-icons';
import { Avatar, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface IProps {
  id: string;
  fullName: string;
  isAvailable: boolean;
  isFavorite: boolean;
  isSelected: boolean;
  profileImage: string;
  profession?: string;
  onItemClick: (id: string) => void;
  jobId?: string;
  isInviteSent?: boolean;
}

export const ListItemLegacy = ({
  fullName,
  id,
  isAvailable,
  isFavorite,
  isSelected,
  profession,
  profileImage,
  onItemClick,
  isInviteSent = false,
}: IProps) => {
  return (
    <AnimatePresence>
      <motion.div
        role="presentation"
        data-cy={`invite-popup-row-${id}`}
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        layout
        onClick={() => !isInviteSent && onItemClick(id)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '8px 0px',
          borderBottom: `1px solid ${colors.neutral[100]}`,
          cursor: isInviteSent ? 'auto' : 'pointer',
        }}
      >
        <Row alignItems="center" gap={12} width="100%">
          <Box
            border={`2px solid ${isFavorite ? colors.favorites[400] : 'transparent'}`}
            borderRadius="100%"
            padding={2}
            position="relative"
          >
            <Avatar size="xl" src={profileImage || undefined} alt="profile_image" />
            {isFavorite && (
              <div style={{ position: 'absolute', top: '75%', right: 0 }}>
                <SolidHeartIcon color={colors.favorites[400]} />
              </div>
            )}
          </Box>

          <Column flex={1}>
            <Typography
              as="span"
              bold
              size="heading_4"
              numberOfLines={1}
              style={{ maxWidth: 280 }}
            >
              {fullName}
            </Typography>
            <Typography as="span">{isAvailable ? profession : 'Currently unavailable'}</Typography>
          </Column>

          {isInviteSent ? (
            <motion.div
              data-cy={`invite-popup-sent-${id}`}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3 }}
              style={{
                display: 'flex',
                alignItems: 'center',
                columnGap: 5,
              }}
            >
              <OutlineDoubleCheckSentIcon size={24} color={colors.neutral[400]} />

              <Typography as="span" color={colors.neutral[400]} size="caption">
                Sent
              </Typography>
            </motion.div>
          ) : (
            <Checkbox
              checked={isSelected}
              style={{
                height: 18,
                width: 18,
              }}
            />
          )}
        </Row>
      </motion.div>
    </AnimatePresence>
  );
};
